/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ js: NonNullable<unknown> }} Archive_DescriptionInputs */

const fr_archive_description = /** @type {(inputs: Archive_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`L'archive contient ${i?.js} (le CSS est intégré).`)
};

const en_archive_description = /** @type {(inputs: Archive_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The archive contains ${i?.js} (CSS is bundled in).`)
};

/**
* | output |
* | --- |
* | "The archive contains {js} (CSS is bundled in)." |
*
* @param {Archive_DescriptionInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const archive_description = /** @type {((inputs: Archive_DescriptionInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Archive_DescriptionInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_archive_description(inputs)
	return en_archive_description(inputs)
});